import { render, staticRenderFns } from "./NotifyPlan.vue?vue&type=template&id=35cefbd0&scoped=true&"
import script from "./NotifyPlan.vue?vue&type=script&lang=js&"
export * from "./NotifyPlan.vue?vue&type=script&lang=js&"
import style0 from "./NotifyPlan.vue?vue&type=style&index=0&id=35cefbd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cefbd0",
  null
  
)

export default component.exports